import { createSlice } from "@reduxjs/toolkit";
import TransportationIcon from "images/Templates View Icons/Industry/Car Side Light 1.svg";
import LegalIcon from "images/Templates View Icons/Industry/Gavel Light 1.svg";
import EducationIcon from "images/Templates View Icons/Industry/Graduation Cap Icon 1.svg";
import CPGManuIcon from "images/Templates View Icons/Industry/Industry Windows Light 1.svg";
import HealthcareIcon from "images/Templates View Icons/Industry/Medical Light Icon 1.svg";
import RetailIcon from "images/Templates View Icons/Industry/Shopping Cart Icon 1.svg";
import ConstructionIcon from "images/Templates View Icons/Industry/Traffic Cone Light 1.svg";
import NLQIcon from "images/Templates View Icons/Type/Simple Light Chart (1).svg";
import VideoIcon from "images/Templates View Icons/Type/Video Light.svg";
import AudioIcon from "images/Templates View Icons/Type/Volume Light Icon.svg";
import SparklesIcon from "images/Templates View Icons/Type/Magic Sparkles Light (1).svg";
import BenchmarkIcon from "images/Templates View Icons/Type/benchmark.svg";
import WhatsChangedOverviewIcon from "images/Templates View Icons/Type/overview.svg";
import ImageIcon from "images/Templates View Icons/Type/Light Icon (1).svg";
import FilesIcon from "images/Templates View Icons/Type/Font Awesome Files Light (1).svg";
import CommentsIcon from "images/Templates View Icons/Type/Comments Light.svg";
import AnalyticsBgImg from "images/Templates View Icons/Type Backgrounds/analytics.svg";
import AudioBgImg from "images/Templates View Icons/Type Backgrounds/audio.svg";
import DocSumBgImg from "images/Templates View Icons/Type Backgrounds/doc-summ.svg";
import ImageBgImg from "images/Templates View Icons/Type Backgrounds/image.svg";
import JustChatBgImg from "images/Templates View Icons/Type Backgrounds/just-chat.svg";
import NLQBgImg from "images/Templates View Icons/Type Backgrounds/nlq.svg";
import BalanceIcon from "images/G/Balance.svg";
import AgricultureIcon from "images/Templates View Icons/Industry/Agriculture.svg";
import BankingIcon from "images/Templates View Icons/Industry/Banking.svg";
import TelecomIcon from "images/Templates View Icons/Industry/Telecom.svg";
import VideoBgImg from "images/Templates View Icons/Type Backgrounds/video.svg";
import ImageToTextIcon from "images/Agent Icons/Capabilities Icons/Light Image Sparkle 1.svg";
import ImageToTextPurpleIcon from "images/Agent Icons/Capabilities Icons/Light Image Sparkle 1 Purple.svg";
import OngoingImprovementsIcon from "images/Agent Icons/Capabilities Icons/Light Microchip AI Rotate 1.svg";
import OngoingImprovementsPurpleIcon from "images/Agent Icons/Capabilities Icons/Light Microchip AI Rotate 1 Purple.svg";
import VideoToTextIcon from "images/Agent Icons/Capabilities Icons/Light Video Sparkle.svg";
import VideoToTextPurpleIcon from "images/Agent Icons/Capabilities Icons/Light Video Sparkle Purple.svg";
import AudioToTextIcon from "images/Agent Icons/Capabilities Icons/Light Waveform Lines Sparkle.svg";
import AudioToTextPurpleIcon from "images/Agent Icons/Capabilities Icons/Light Waveform Lines Sparkle Purple.svg";
import EventAnalysisIcon from "images/Agent Icons/Capabilities Icons/Magnifying Glass Waveform Icon 1.svg";
import EventAnalysisPurpleIcon from "images/Agent Icons/Capabilities Icons/Magnifying Glass Waveform Icon 1 Purple.svg";
import GuardrailsCheckIcon from "images/Agent Icons/Capabilities Icons/Shield Check Light 1.svg";
import GuardrailsCheckPurpleIcon from "images/Agent Icons/Capabilities Icons/Shield Check Light 1 Purple.svg";
import EvaluatingImageBlueprintIcon from "images/Agent Icons/Capabilities Icons/Light Icon Full.svg";
import EvaluatingImageBlueprintIconPurple from "images/Agent Icons/Capabilities Icons/Light Icon Full Purple.svg";
import GeneratingMetadataBlueprintIcon from "images/Agent Icons/Capabilities Icons/Light Align Left Sparkle.svg";
import GeneratingMetadataBlueprintIconPurple from "images/Agent Icons/Capabilities Icons/Light Align Left Sparkle Purple.svg";
import GeneratingModelBlueprintIcon from "images/Agent Icons/Capabilities Icons/Thin Cube Sparkle.svg";
import GeneratingModelBlueprintIconPurple from "images/Agent Icons/Capabilities Icons/Thin Cube Sparkle Purple.svg";
import OptimizeStepIcon from "images/Agent Icons/Capabilities Icons/Magnifying Glass Waveform Icon 1.svg";
import OptimizeStepIconActive from "images/Agent Icons/Capabilities Icons/Magnifying Glass Waveform Icon 1 Purple.svg";
import RadarIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/gray/Radar Sharp Light 1.svg";
import RadarPurpleIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/purple/Radar Sharp Light 2.svg";
import MoneyIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/gray/money-bill-wave-light (1) 1.svg";
import MoneyPurpleIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/purple/money-bill-wave-light (1) 2.svg";
import FunnelIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/gray/Filter Light Icon 1.svg";
import FunnelPurpleIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/purple/Filter Light Icon 2.svg";
import BullseyeIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/gray/bullseye-arrow-light 1.svg";
import BullseyePurpleIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/purple/bullseye-arrow-light 2.svg";
import GaugeIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/gray/Gauge High Light 1.svg";
import GaugePurpleIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/purple/Gauge High Light 2.svg";
import ChartsIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/gray/Bullet Chart Duotone 1.svg";
import ChartsPurpleIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/purple/Bullet Chart Duotone 2.svg";
import CrystalBallIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/gray/Crystal Ball Light Full 1.svg";
import CrystalBallPurpleIcon from "images/Agent Icons/Capabilities Icons/optimize_step_icons/purple/Crystal Ball Light Full 2.svg";
import FlaskIcon from "images/Agent Icons/flask-light-gray.svg";
export const DEFAULT_INDUSTRY_TAGS = {
    0: {
        id: 0,
        label: "Manufacturing",
        icon: CPGManuIcon,
        type: "INDUSTRY",
        sortRank: 3
    },
    1: {
        id: 1,
        label: "Healthcare",
        icon: HealthcareIcon,
        type: "INDUSTRY",
        sortRank: 2
    },
    2: {
        id: 2,
        label: "Education",
        icon: EducationIcon,
        type: "INDUSTRY",
        sortRank: 9
    },
    5: {
        id: 5,
        label: "Construction",
        icon: ConstructionIcon,
        type: "INDUSTRY",
        sortRank: 8
    },
    // 6: {
    //   id: 6,
    //   label: "Distribution",
    //   icon: DistributionIcon,
    //   type: "INDUSTRY",
    //   sortRank: 100
    // },
    // 3: {
    //   id: 3,
    //   label: "Software / Technology",
    //   icon: SoftwareIcon,
    //   type: "INDUSTRY",
    //   sortRank: 100
    // },
    // 4: {
    //   id: 4,
    //   label: "Food & Beverage",
    //   icon: FoodBevIcon,
    //   type: "INDUSTRY",
    //   sortRank: 100
    // },
    7: {
        id: 7,
        label: "Retail",
        icon: RetailIcon,
        type: "INDUSTRY",
        sortRank: 1
    },
    8: {
        id: 8,
        label: "Legal",
        icon: LegalIcon,
        type: "INDUSTRY",
        sortRank: 6
    },
    9: {
        id: 9,
        label: "Transportation",
        icon: TransportationIcon,
        type: "INDUSTRY",
        sortRank: 7
    },
    27: {
        id: 27,
        label: "Agriculture",
        icon: AgricultureIcon,
        type: "INDUSTRY",
        sortRank: 10
    },
    TELECOM: {
        id: "TELECOM",
        label: "Telecommunications",
        icon: TelecomIcon,
        type: "INDUSTRY",
        sortRank: 5
    },
    BANKING: {
        id: "BANKING",
        label: "Financial Services & Insurance",
        icon: BankingIcon,
        type: "INDUSTRY",
        sortRank: 4
    }
};
const DEFAULT_FUNCTION_TAGS = {
    10: {
        id: 10,
        label: "Sales",
        icon: undefined,
        type: "FUNCTION",
        sortRank: 1
    },
    11: {
        id: 11,
        label: "Logistics Optimization",
        icon: undefined,
        type: "FUNCTION",
        sortRank: 2
    },
    12: {
        id: 12,
        label: "Customer Retention",
        icon: undefined,
        type: "FUNCTION",
        sortRank: 3
    },
    13: {
        id: 13,
        label: "Marketing Optimization",
        icon: undefined,
        type: "FUNCTION",
        sortRank: 4
    },
    14: {
        id: 14,
        label: "Collections",
        icon: undefined,
        type: "FUNCTION",
        sortRank: 5
    },
    15: {
        id: 15,
        label: "Customer Experience",
        icon: undefined,
        type: "FUNCTION",
        sortRank: 6
    },
    // 16: {
    //   id: 16,
    //   label: "Health Analytics",
    //   icon: undefined,
    //   type: "FUNCTION"
    // },
    26: {
        id: 26,
        label: "Safety",
        icon: undefined,
        type: "FUNCTION",
        sortRank: 7
    },
    HUMAN_RESOURCES: {
        id: "HUMAN_RESOURCES",
        label: "Human Resources",
        icon: undefined,
        type: "FUNCTION",
        sortRank: 8
    }
};
const DEFAULT_TYPE_TAGS = {
    WHATS_CHANGED: {
        id: "WHATS_CHANGED",
        label: "Whats Changed Overview & Deep Dive",
        icon: WhatsChangedOverviewIcon,
        type: "TYPE",
        sortRank: 2
    },
    BENCHMARK: {
        id: "BENCHMARK",
        label: "Benchmark",
        icon: BenchmarkIcon,
        type: "TYPE",
        sortRank: 3
    },
    17: {
        id: 17,
        label: "Agentic Analytics",
        icon: SparklesIcon,
        type: "TYPE",
        background: AnalyticsBgImg,
        sortRank: 4
    },
    18: {
        id: 18,
        label: "Data Query (NLQ)",
        icon: NLQIcon,
        type: "TYPE",
        background: NLQBgImg,
        sortRank: 6
    },
    19: {
        id: 19,
        label: "Chat Only",
        icon: CommentsIcon,
        type: "TYPE",
        background: JustChatBgImg,
        sortRank: 9
    },
    // 20: {
    //   id: 20,
    //   label: "Predictions/Optimization",
    //   icon: CrystalBallIcon,
    //   type: "TYPE",
    //   background: PredictBgImg,
    //   sortRank: 100
    // },
    21: {
        id: 21,
        label: "Document Summarization",
        icon: FilesIcon,
        type: "TYPE",
        background: DocSumBgImg,
        sortRank: 5
    },
    // 22: {
    //   id: 22,
    //   label: "Multi-step Agent",
    //   icon: AgentIcon,
    //   type: "TYPE",
    //   background: AgentBgImg,
    // },
    23: {
        id: 23,
        label: "Video",
        icon: VideoIcon,
        type: "TYPE",
        background: VideoBgImg,
        sortRank: 10
    },
    24: {
        id: 24,
        label: "Image",
        icon: ImageIcon,
        type: "TYPE",
        background: ImageBgImg,
        sortRank: 8
    },
    25: {
        id: 25,
        label: "Audio",
        icon: AudioIcon,
        type: "TYPE",
        background: AudioBgImg,
        sortRank: 11
    },
    AI_BLUEPRINT: {
        id: "AI_BLUEPRINT",
        label: "NVIDIA Blueprint",
        type: "TYPE",
        sortRank: 12
    },
    OPTIMIZE: {
        id: "OPTIMIZE",
        icon: BalanceIcon,
        label: "Business Optimization",
        type: "TYPE",
        sortRank: 6
    },
    AIBLE_SAFE_CLAW: {
        id: "AIBLE_SAFE_CLAW",
        icon: FlaskIcon,
        label: "Long-Running Agent",
        type: "TYPE",
        sortRank: 1,
        tooltip: {
            tooltipStyle: { maxWidth: "400px" },
            title: "Aible Labs Experimental Feature",
            titleStyle: { fontWeight: "bold" },
            text: "Automatically create long-running agents that wake up periodically (heartbeat) and on schedules (cron jobs) to perform specific activities using shared memory and communicate their activities across common channels like Slack."
        }
    }
};
export const DEFAULT_TAGS = {
    ...DEFAULT_INDUSTRY_TAGS,
    ...DEFAULT_FUNCTION_TAGS,
    ...DEFAULT_TYPE_TAGS
};
export const DEFAULT_CAPABILITIES = {
    Chat: {
        label: "User submits chat",
        description: "Answer with specific content from the documents. This is best when the user questions will require highly detailed information from the documents.",
        icon: CommentsIcon
    },
    Agent: {
        label: "Agent identifies",
        description: "Answer with specific content from the documents. This is best when the user questions will require highly detailed information from the documents.",
        icon: CommentsIcon
    },
    Fast: {
        label: "Speed Preference: Faster Answers",
        description: "This will result in quicker responses",
        icon: CommentsIcon
    }
};
export const AGENT_CAPABILITIES = {
    image: [
        {
            model: "",
            label: "Image to Text",
            description: "Model converts images to a text description of the image submitted",
            icon: ImageToTextIcon,
            activeIcon: ImageToTextPurpleIcon
        },
        {
            model: "",
            label: "Event Analysis",
            description: "Determines if the description of the events matches the criteria",
            icon: EventAnalysisIcon,
            activeIcon: EventAnalysisPurpleIcon
        },
        {
            model: "",
            label: "Ongoing Improvement",
            description: "Automatic event analysis updates based on the users feedback",
            icon: OngoingImprovementsIcon,
            activeIcon: OngoingImprovementsPurpleIcon
        }
    ],
    image_reasoning: [
        {
            model: "",
            label: "Image to Text",
            description: "Model converts images to a text description of the image submitted",
            icon: ImageToTextIcon,
            activeIcon: ImageToTextPurpleIcon
        },
        {
            model: "",
            label: "Event Analysis",
            description: "Determines if the description of the events matches the criteria",
            icon: EventAnalysisIcon,
            activeIcon: EventAnalysisPurpleIcon
        },
        {
            model: "",
            label: "Ongoing Improvement",
            description: "Automatic event analysis updates based on the users feedback",
            icon: OngoingImprovementsIcon,
            activeIcon: OngoingImprovementsPurpleIcon
        }
    ],
    video: [
        {
            model: "gemini-1.5-pro",
            label: "Video to Text",
            description: "Model converts video to a text description of the video file submitted",
            icon: VideoToTextIcon,
            activeIcon: VideoToTextPurpleIcon
        },
        {
            model: "gemini-1.5-pro",
            label: "Event Analysis",
            description: "Determines if the description of the video file matches the event criteria",
            icon: EventAnalysisIcon,
            activeIcon: EventAnalysisPurpleIcon
        },
        {
            model: "",
            label: "Ongoing Improvement",
            description: "Automatic event analysis updates based on the users feedback",
            icon: OngoingImprovementsIcon,
            activeIcon: OngoingImprovementsPurpleIcon
        }
    ],
    audio: [
        {
            model: "OmniAudio-2.6B",
            label: "Audio to Text",
            description: "Model converts audio to a text description of the audio file submitted",
            icon: AudioToTextIcon,
            activeIcon: AudioToTextPurpleIcon
        },
        {
            model: "Llama-3.1-8b-Instruct",
            label: "Event Analysis",
            description: "Determines if the description of the audio file matches the event criteria",
            icon: EventAnalysisIcon,
            activeIcon: EventAnalysisPurpleIcon
        },
        {
            model: "",
            label: "Ongoing Improvement",
            description: "Automatic event analysis updates based on the users feedback",
            icon: OngoingImprovementsIcon,
            activeIcon: OngoingImprovementsPurpleIcon
        }
    ],
    guardrails_gemini: {
        model: "gemini-1.5-pro",
        label: "Guardrail Validation",
        description: "Verifies that race, gender, and other bias was not used in the image description",
        icon: GuardrailsCheckIcon,
        activeIcon: GuardrailsCheckPurpleIcon
    },
    guardrails_local: {
        model: "Llama-3.1-8b-Instruct",
        label: "Guardrail Validation",
        description: "Verifies that race, gender, and other bias was not used in the image description",
        icon: GuardrailsCheckIcon,
        activeIcon: GuardrailsCheckPurpleIcon
    },
    AI_BLUEPRINT_RETAIL_CATALOG: [
        {
            model: "",
            label: "Evaluating Image",
            description: "Gathering context from the uploaded image",
            icon: EvaluatingImageBlueprintIcon,
            activeIcon: EvaluatingImageBlueprintIconPurple
        },
        {
            model: "",
            label: "Generating Description",
            description: "Creating product title, description, categories, tags based on image and brand guidelines",
            icon: GeneratingMetadataBlueprintIcon,
            activeIcon: GeneratingMetadataBlueprintIconPurple
        },
        {
            model: "",
            label: "Generating Images",
            description: "Creating images of the product in different settings",
            icon: ImageToTextIcon,
            activeIcon: ImageToTextPurpleIcon
        },
        {
            model: "",
            label: "Generating 3D Model",
            description: "Creating an interactive model for the users",
            icon: GeneratingModelBlueprintIcon,
            activeIcon: GeneratingModelBlueprintIconPurple
        }
    ],
    optimize: [
        {
            id: "UNDERSTAND_QUESTION",
            model: "",
            label: "Understanding the Question",
            description: "Analyzing your question to determine user intent",
            icon: OptimizeStepIcon,
            activeIcon: OptimizeStepIconActive
        },
        {
            id: "DATASET_SEARCH",
            model: "",
            label: "Finding Relevant Data and Use Cases",
            description: "Identifying the best data and settings to answer your question",
            icon: RadarIcon,
            activeIcon: RadarPurpleIcon
        },
        {
            id: "BUSINESS_COSTS",
            model: "",
            label: "Business Costs",
            description: "Automatic adjustments based on your business constraints",
            icon: MoneyIcon,
            activeIcon: MoneyPurpleIcon
        },
        {
            id: "BASELINE_BEHAVIOR",
            model: "",
            label: "Baseline Behavior",
            description: "Automatic optimization based on your expected behavior",
            icon: FunnelIcon,
            activeIcon: FunnelPurpleIcon
        },
        {
            id: "BUSINESS_STRATEGY",
            model: "",
            label: "Strategy",
            description: "Adjusting resource allocation based on your set strategy",
            icon: BullseyeIcon,
            activeIcon: BullseyePurpleIcon
        },
        {
            id: "OPTIMIZE_RESULTS",
            model: "",
            label: "Expected Improvements",
            description: "Review the optimized results for your unique business scenario",
            icon: GaugeIcon,
            activeIcon: GaugePurpleIcon
        },
        {
            id: "MODEL_DRIVERS",
            model: "",
            label: "Model Drivers",
            description: "Discover what factors in the data drive business outcomes",
            icon: ChartsIcon,
            activeIcon: ChartsPurpleIcon
        },
        {
            id: "WHAT_IF_SCENARIOS",
            model: "",
            label: "What If Scenarios",
            description: "See predicted outcomes for different groups",
            icon: CrystalBallIcon,
            activeIcon: CrystalBallPurpleIcon
        }
    ]
};
function updateTagFromState(state, tag, id) {
    return {
        ...state,
        tags: {
            ...state.tags,
            [id]: tag
        }
    };
}
function deleteTagFromState(state, tag, id) {
    const newState = {
        ...state,
        tags: {
            ...state.tags
        }
    };
    delete newState.tags[id];
    return newState;
}
function updateFilterOptionsFromState(state, ids) {
    const newState = {
        ...state,
        filterOptions: ids
    };
    return newState;
}
function updateActiveFiltersFromState(state, ids) {
    const newState = {
        ...state,
        activeFilters: ids
    };
    return newState;
}
function updateActiveCapabilityFromState(state, val) {
    const newState = {
        ...state,
        activeCapability: val
    };
    return newState;
}
function updateCapabilityTimerIdFromState(state, val) {
    const newState = {
        ...state,
        capabilityTimerId: val
    };
    return newState;
}
const initialState = {
    tags: DEFAULT_TAGS,
    filterOptions: [],
    activeFilters: [],
    activeCapability: undefined,
    capabilityTimerId: undefined
};
const tagsSlice = createSlice({
    name: "tags",
    initialState,
    reducers: {
        // Tags
        updateTag(state, { payload }) {
            return updateTagFromState(state, payload, payload.id);
        },
        updateTags(state, { payload }) {
            return payload.reduce(updateTagFromState, state);
        },
        deleteTag(state, { payload }) {
            return deleteTagFromState(state, payload, payload.id);
        },
        // Filter Options
        updateFilterOptions(state, { payload }) {
            return updateFilterOptionsFromState(state, payload);
        },
        // Active Filters
        updateActiveFilters(state, { payload }) {
            return updateActiveFiltersFromState(state, payload);
        },
        // Active Capability
        updateActiveCapability(state, { payload }) {
            return updateActiveCapabilityFromState(state, payload);
        },
        updateCapabilityTimerId(state, { payload }) {
            return updateCapabilityTimerIdFromState(state, payload);
        }
    }
});
export default tagsSlice.reducer;
function getBase(state) {
    return state.tags;
}
export function getTags(state) {
    return getBase(state).tags;
}
export function getTagById(state, id) {
    return getBase(state).tags[id];
}
export function getFilterOptions(state) {
    return getBase(state).filterOptions ?? [];
}
export function getActiveFilters(state) {
    return getBase(state).activeFilters ?? [];
}
export function getActiveCapability(state) {
    return getBase(state)?.activeCapability;
}
export function getCapabilityTimerId(state) {
    return getBase(state)?.capabilityTimerId;
}
export function getTagsByType(state, type) {
    const allTags = getTags(state);
    const tags = Object.keys(allTags)
        .filter((tagKey) => allTags[tagKey]?.type === type)
        .map((tagId) => allTags[tagId]);
    tags.sort((t1, t2) => t1.sortRank - t2.sortRank);
    return tags;
}
export function getFilterOptionsByType(state, type) {
    const filterOptions = getFilterOptions(state);
    const allTags = getTags(state);
    return filterOptions.filter((optionId) => allTags[optionId]?.type === type).map((tagId) => allTags[tagId]);
}
export function getActiveFiltersByType(state, type) {
    const activeFilters = getActiveFilters(state);
    const allTags = getTags(state);
    return activeFilters.filter((filterId) => allTags[filterId]?.type === type);
}
export function addFilterOption(id) {
    return (dispatch, getState) => {
        const filterOptions = getFilterOptions(getState());
        const retFilterOptions = [...filterOptions];
        if (!filterOptions.includes(id)) {
            retFilterOptions.push(id);
            return dispatch(tagsSlice.actions.updateFilterOptions(retFilterOptions));
        }
        return;
    };
}
export function updateAllFilterOptions(ids) {
    return (dispatch, getState) => {
        return dispatch(tagsSlice.actions.updateFilterOptions(ids));
    };
}
export function resetFilterOptions() {
    return (dispatch, getState) => {
        return dispatch(tagsSlice.actions.updateFilterOptions([]));
    };
}
export function toggleActiveTagFilter(id) {
    return (dispatch, getState) => {
        const activeFilters = getActiveFilters(getState());
        const retActiveFilters = [...activeFilters];
        if (activeFilters.indexOf(id) === -1) {
            retActiveFilters.push(id);
        }
        else {
            const spliceIndex = retActiveFilters.indexOf(id);
            retActiveFilters.splice(spliceIndex, 1);
        }
        return dispatch(tagsSlice.actions.updateActiveFilters(retActiveFilters));
    };
}
export function resetActiveTagFilters() {
    return (dispatch, getState) => {
        return dispatch(tagsSlice.actions.updateActiveFilters([]));
    };
}
export function getShouldShowTaggedItem(itemTags) {
    return (dispatch, getState) => {
        const activeFilters = getActiveFilters(getState());
        if (activeFilters.length < 1) {
            return true;
        }
        const industryFilters = getActiveFiltersByType(getState(), "INDUSTRY");
        const functionFilters = getActiveFiltersByType(getState(), "FUNCTION");
        const typeFilters = getActiveFiltersByType(getState(), "TYPE");
        const shouldShowIndustry = itemTags?.some((tag) => industryFilters?.includes(tag));
        const shouldShowFunction = itemTags?.some((tag) => functionFilters?.includes(tag));
        const shouldShowType = itemTags?.some((tag) => typeFilters?.includes(tag));
        if (shouldShowIndustry || shouldShowFunction || shouldShowType) {
            return true;
        }
        return false;
    };
}
export function updateActiveCapability(val) {
    return (dispatch, getState) => {
        return dispatch(tagsSlice.actions.updateActiveCapability(val));
    };
}
export function updateCapabilityTimerId(val) {
    return (dispatch, getState) => {
        return dispatch(tagsSlice.actions.updateCapabilityTimerId(val));
    };
}
